import { RouteObject, useRoutes } from 'react-router';
import { Navigate } from 'react-router-dom';

import { paths } from 'configuration/paths';
import { ProtectedRoute } from 'components/ProtectedRoute';
import Login from 'pages/Login';
import Error500 from 'pages/Error500';
import MySurveys from 'pages/MySurveys';
import SurveyIntro from 'pages/SurveyIntro';
import Survey from 'pages/Survey';
import SurveySection from 'pages/SurveySection';
import SurveyWrapUp from 'pages/SurveyWrapUp';
import ViewSurvey from './pages/ViewSurvey';
import './App.module.scss';

const AppRoutes = () => {
  const routes = [
    {
      path: paths.login,
      element: <Login />
    },
    {
      path: paths.error,
      element: <Error500 />
    },
    {
      path: paths.mySurveys,
      element: <Navigate to={paths.mySurveys_planned} replace />
    },
    {
      path: paths.mySurveys_planned,
      element: (
        <ProtectedRoute>
          <MySurveys />
        </ProtectedRoute>
      )
    },
    {
      path: paths.mySurveys_inProgress,
      element: (
        <ProtectedRoute>
          <MySurveys />
        </ProtectedRoute>
      )
    },
    {
      path: paths.mySurveys_completed,
      element: (
        <ProtectedRoute>
          <MySurveys />
        </ProtectedRoute>
      )
    },
    {
      path: paths.surveyIntro,
      element: (
        <ProtectedRoute>
          <SurveyIntro />
        </ProtectedRoute>
      )
    },
    {
      path: paths.surveyIntroFromVisit,
      element: (
        <ProtectedRoute>
          <SurveyIntro />
        </ProtectedRoute>
      )
    },
    {
      path: paths.surveyIntroExistingSurvey,
      element: (
        <ProtectedRoute>
          <SurveyIntro />
        </ProtectedRoute>
      )
    },
    {
      path: paths.survey,
      element: (
        <ProtectedRoute>
          <Survey />
        </ProtectedRoute>
      )
    },
    {
      path: paths.surveySection,
      element: (
        <ProtectedRoute>
          <SurveySection />
        </ProtectedRoute>
      )
    },
    {
      path: paths.surveyWrapUp,
      element: (
        <ProtectedRoute>
          <SurveyWrapUp />
        </ProtectedRoute>
      )
    },
    {
      path: paths.viewSurvey,
      element: (
        <ProtectedRoute>
          <ViewSurvey />
        </ProtectedRoute>
      )
    },
    {
      path: '*',
      element: (
        <ProtectedRoute>
          <Navigate to={paths.mySurveys} replace />
        </ProtectedRoute>
      )
    }
  ] as RouteObject[];

  return useRoutes(routes);
};

export default AppRoutes;
